export default "__VITE_ASSET__Db1AQk9f__"